import React, {Component} from 'react';
import CollapseText from "~/ui/ReactML/CollapseText";
import PopupList from "~/ui/ReactML/PopupList";
import Icon from "~/ui/ReactML/Icon";
import { deriveNewListOrder } from '~/statePresenter';
import { renderHTML } from "~/native-ui";
import { TableView } from "./TableView";
export default class ResultTable extends Component {
    getRowActions = () => {
        let actions = [];
        let { trans } = this.props;

        actions.push(
            { label: trans('show'), icon: 'remove_red_eye', onClick: (entry) => this.props.viewEntry(entry) }
        );

        if(this.props.editEntry) {
            actions.push(
                { label: trans('edit'), icon: 'mode_edit', onClick: (entry) => this.props.editEntry(entry) },
            );
        }

        return actions;
    };

    renderHtml = (html) => {
        return renderHTML(html, {
            Text: CollapseText,
            ul: PopupList,
            icon: Icon
        })
    };

    render() {
        let { resultValue, tooltipsActive, tableContainerClassName, tableSettingsTooltip, } = this.props;

        return (
                <TableView
                    scroll

                    tooltipsActive={tooltipsActive}
                    tableSettingsTooltip={tableSettingsTooltip}
                    tableContainerClassName={tableContainerClassName}

                    columns={this.props.visibleColumns}
                    results={resultValue.results}

                    sortOptions={this.props.sortOptions}
                    perPage={this.props.perPage}
                    multiSelectable={this.props.multiSelectable}
                    columnWidths={this.props.columnWidths}
                    columnOrder={this.props.columnOrder}

                    deriveNewListOrder={deriveNewListOrder}
                    page={resultValue.page}
                    total={resultValue.total}
                    autoHeight={this.props.autoHeight}
                    colorBlend={this.props.colorBlend}
                    onSortChange={this.props.changeSort}
                    onChangePage={this.props.changePage}
                    onChangePerPage={this.props.changePerPage}
                    onSelectedRowsChange={this.props.onRowSelect}
                    hasSelections={this.props.hasSelections}
                    onColumnResizeEnd={this.props.onColumnResize}
                    onRowClick={this.props.editEntry || this.props.viewEntry}
                    // onRowDoubleClick={this.props.editEntry || this.props.viewEntry}
                    rowActions={this.getRowActions()}
                    onColumnReorder={this.props.onColumnReorder}
                    searchFilterValue={this.props.searchFilterValue}
                    canSort={this.props.canSort}
                    canResize={this.props.canResize}
                    
                    renderHTML={this.renderHtml}
                />
        );
    }
}